import { defineStore } from 'pinia';

export const useBibleStore = defineStore('bible', {
    state: () => ({
        bibleData: null,
        loading: false,
        error: null
    }),
    actions: {
        async loadBibleData() {
            if (this.bibleData) return; // Already loaded

            this.loading = true;
            try {
                const response = await fetch('/bible_structure_kjv.json');
                if (!response.ok) throw new Error('Failed to load Bible data');
                this.bibleData = await response.json();
            } catch (err) {
                console.error("Bible Store Error:", err);
                this.error = "Failed to load Bible structure.";
            } finally {
                this.loading = false;
            }
        },
        getBook(bookName) {
            // Helper to find book by name
            return this.bibleData?.books?.find(b => b.name === bookName || b.abbreviation === bookName);
        }
    }
});
